import { useEffect, useState } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";

import { Pagination } from "@mui/material";

// components
import LoadList from "../../components/LoadList";
import SearchStuff from "../../components/SearchStuff";
import LoadsFilter from "./LoadsFilter";
import SearchDates from "../../components/SearchDates";
import ErrorDisplay from "../../components/ErrorDisplay";

// styles and images
import "./Project.css";
import Lock from "../../assets/lock.svg";
import Download from "../../assets/download.svg";

// global
import { accountDataStore, projectStore, userStore } from "../../store/Store";

// internal hooks
import { useGetUniqueOptions } from "../../hooks/useGetUniqueOptions";
import useGetFetch from "../../hooks/useGetFetch";

// data
import {
  loadApprovalStatus,
  loadBatchActionOptions,
} from "../../data/collections-data";

// funcs
import { GenerateLoadsDownload } from "../../funcs/download/downloadLoads";
import BatchUpdatePopup from "../../components/BatchUpdatePopup";

export default function Loads({
  setLoadLockTrigger,
  setIsAsset,
  setLockEndpoint,
}) {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const projectLoads = projectStore((data) => data.projectLoads);
  const setProjectTotals = projectStore((data) => data.setProjectTotals);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices,
  );
  const projectVendorInvoices = projectStore(
    (data) => data.projectVendorInvoices,
  );
  const currentProject = projectStore((data) => data.currentProject);
  const accountCustomerInvoices = accountDataStore(
    (data) => data.accountCustomerInvoices,
  );
  const accountVendorInvoices = accountDataStore(
    (data) => data.accountVendorInvoices,
  );

  // batch actions
  const [triggerBatchUpdate, setTriggerBatchUpdate] = useState(false);
  const [enableCheckBoxes, setEnableCheckBoxes] = useState(false);
  const [batchLoads, setBatchLoads] = useState([]);
  const [batchChecked, setBatchChecked] = useState(false);
  const [reqBody, setReqBody] = useState(null);
  const [title, setTitle] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // other
  const { id } = useParams("id");
  const [perPage, setPerPage] = useState(25);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [paginatedLoads, setPagninatedLoads] = useState(projectLoads);
  const [loadsSearch, setLoadsSearch] = useState([]);
  const [loadsFilter, setLoadsFilter] = useState(projectLoads);
  const [carrierDD, setCarrierDD] = useState(null);
  const [terminalDD, setTerminalDD] = useState(null);
  const [productDD, setProductDD] = useState(null);
  const [poDD, setPoDD] = useState(null);
  const [customerInvoiceDD, setCustomerInvoiceDD] = useState([]);
  const [uniqueInvoices, setUniqueInvoices] = useState();
  const [currFilter, setCurrFilter] = useState("all");
  const [filterOptions, setFilterOptions] = useState({
    load: "",
    carrier: "",
    terminal: "",
    customer_invoice: "",
    approval_status: "",
    po_number: "",
  });
  const pageOptions = [
    {
      value: 10,
      label: 10,
    },
    {
      value: 25,
      label: 25,
    },
    {
      value: 100,
      label: 100,
    },
  ];

  // get values for filters
  useGetUniqueOptions(setCarrierDD, projectLoads, "carrier_name");
  useGetUniqueOptions(setTerminalDD, projectLoads, "terminal_name");
  useGetUniqueOptions(setProductDD, projectLoads, "product_name");
  useGetUniqueOptions(setPoDD, projectLoads, "po_number");

  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/unique-customer-invoices/${id}`,
    setUniqueInvoices,
  );

  // get customer invoice dropdown
  useEffect(() => {
    const invoices = [{ value: 0, label: "All" }];
    
    if (uniqueInvoices) {
      uniqueInvoices.forEach((i) => {
        if (i.is_account_invoice) {
          invoices.push({ value: `${i.id}-true`, label: i.invoice_name });
        } else {
          invoices.push({ value: `${i.id}-false`, label: i.invoice_name });
        }
      });
    }
    setCustomerInvoiceDD(invoices);
  }, [uniqueInvoices, setCustomerInvoiceDD]);

  const selectPage = (_, p) => {
    setPage(p);
  };

  const selectPerPage = (k, _) => {
    setPerPage(k.label);
    setPage(1);
  };

  useEffect(() => {
    if (projectLoads) {
      if (loadsSearch.length === 0) {
        const loadsLength = loadsFilter.length;
        setCount(Math.ceil(loadsLength / perPage));
      } else {
        const loadsLength = loadsSearch.length;
        setCount(Math.ceil(loadsLength / perPage));
      }
    }
  }, [projectLoads, perPage, setCount, loadsSearch.length, loadsFilter.length]);

  useEffect(() => {
    setLoadsFilter(projectLoads);
  }, [projectLoads]);

  useEffect(() => {
    var pageLoads = page * perPage;
    var previousPage = page - 1;
    var prevLoads;
    if (previousPage === 0) {
      prevLoads = 1;
    } else {
      prevLoads = previousPage * perPage;
    }
    if (projectLoads) {
      if (loadsSearch.length === 0) {
        const loadsLength = loadsFilter.length;
        if (pageLoads >= loadsLength) {
          if (page === 1) {
            setPagninatedLoads(loadsFilter.slice(0, loadsLength));
          } else {
            setPagninatedLoads(loadsFilter.slice(prevLoads, loadsLength));
          }
        } else {
          setPagninatedLoads(loadsFilter.slice(prevLoads - 1, page * perPage));
        }
      } else {
        const loadsLength = loadsSearch.length;
        if (pageLoads >= loadsLength) {
          if (page === 1) {
            setPagninatedLoads(loadsSearch.slice(0, loadsLength));
          } else {
            setPagninatedLoads(loadsSearch.slice(prevLoads, loadsLength));
          }
        } else {
          setPagninatedLoads(loadsSearch.slice(prevLoads - 1, page * perPage));
        }
      }
    }
  }, [
    page,
    loadsSearch,
    setPagninatedLoads,
    perPage,
    projectLoads,
    loadsFilter,
  ]);

  // enable check boxes
  useEffect(() => {
    setEnableCheckBoxes(false);
    if (currFilter !== "all") {
      setEnableCheckBoxes(true);
    }
  }, [currFilter, filterOptions]);

  const handleLock = () => {
    setLoadLockTrigger(true);
    setLockEndpoint("load");
    setIsAsset(false);
  };

  const handleDownload = () => {
    if (loadsSearch.length === 0) {
      GenerateLoadsDownload(
        loadsFilter,
        currentProject.project.job_name,
        "Loads",
        projectVendorInvoices,
        projectCustomerInvoices,
        accountCustomerInvoices,
        accountVendorInvoices,
      );
    } else {
      GenerateLoadsDownload(
        loadsSearch,
        currentProject.project.job_name,
        "Loads",
        projectVendorInvoices,
        projectCustomerInvoices,
        accountCustomerInvoices,
        accountVendorInvoices,
      );
    }
  };

  const handleBatchChecks = () => {
    setBatchChecked(!batchChecked);
    if (!batchChecked === true) {
      var arr = [];
      paginatedLoads.forEach((l) => {
        arr.push({
          pc_load_id: l.pc_load_id,
          checked: true,
        });
      });
      setBatchLoads(arr);
    } else {
      setBatchLoads([]);
    }
  };

  const handleBatchAction = (o) => {
    const body = {
      pc_load_ids: [],
      action_type: "",
      project_id: currentProject.project.id,
      user_id: currentUser.id,
    };

    batchLoads.forEach((ld) => {
      if (ld.checked) {
        body.pc_load_ids.push(ld.pc_load_id);
      }
      body.action_type = o.label;
      if (body.pc_load_ids.length > 0) {
        setReqBody(body);
        switch (o.label) {
          case "Hard Refresh":
            setTitle(
              "Are you sure you want to perform a hard refresh for all of the selected loads?",
            );
            setSuccessMessage("Hard Refresh Successful");
            setTriggerBatchUpdate(true);
            break;
          default:
            break;
        }
      }
    });
  };
  if (error) {
    return <ErrorDisplay message={"Something Went Wrong"} code={500} />;
  } else {
    return (
      paginatedLoads &&
      !isPending && (
        <div className="container-fluid">
          <div className="col-auto">
            <div className="d-flex justify-content-between card-header">
              <LoadsFilter
                setLoadsFilter={setLoadsFilter}
                setFilterOptions={setFilterOptions}
                setLoadsSearch={setLoadsSearch}
                currFilter={currFilter}
                setCurrFilter={setCurrFilter}
              />
              <div className="d-flex">
                {!currentProject.project.archived && (
                  <img
                    src={Lock}
                    alt="lock"
                    className="project-filter-image"
                    onClick={handleLock}
                  />
                )}
                <img
                  src={Download}
                  alt="download"
                  className="project-delete-image"
                  onClick={handleDownload}
                />
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"load_no"}
                  label={"Load #"}
                  type={"number"}
                  setState={setLoadsSearch}
                  name={"load"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                />
              </div>
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"carrier_name"}
                  setState={setLoadsSearch}
                  name={"carrier"}
                  isSelect={true}
                  options={carrierDD}
                  selectPlaceholder={"Carrier"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                />
              </div>
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"terminal_name"}
                  setState={setLoadsSearch}
                  name={"terminal"}
                  isSelect={true}
                  options={terminalDD}
                  selectPlaceholder={"Terminal"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                />
              </div>
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"product_name"}
                  setState={setLoadsSearch}
                  name={"product"}
                  isSelect={true}
                  options={productDD}
                  selectPlaceholder={"Product"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                />
              </div>
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"po_number"}
                  setState={setLoadsSearch}
                  name={"po_number"}
                  isSelect={true}
                  options={poDD}
                  selectPlaceholder={"PO"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                />
              </div>
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"customer_invoice_id"}
                  setState={setLoadsSearch}
                  name={"customer_invoice"}
                  isSelect={true}
                  options={customerInvoiceDD}
                  selectPlaceholder={"Invoice"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                  useValue={true}
                  isInvoice={true}
                />
              </div>
              <div className="search-stuff-inputs">
                <SearchStuff
                  data={projectLoads}
                  field={"propconnect_approval_status"}
                  setState={setLoadsSearch}
                  name={"approval_status"}
                  isSelect={true}
                  options={loadApprovalStatus}
                  selectPlaceholder={"Status"}
                  filterOptions={filterOptions}
                  setFilterOptions={setFilterOptions}
                  useValue={false}
                />
              </div>
              {batchLoads.length > 0 && (
                <Select
                  key="batch-actions"
                  name="batch-actions"
                  options={loadBatchActionOptions}
                  placeholder="Batch Action"
                  className="col-1"
                  onChange={handleBatchAction}
                />
              )}
              <SearchDates data={projectLoads} setState={setLoadsSearch} />
            </div>
          </div>
          <div className="load-display-list">
            <table className="table table-sm table-hover">
              <thead>
                <tr>
                  {enableCheckBoxes && (
                    <th>
                      <input
                        type="checkbox"
                        name="batch_check"
                        onChange={handleBatchChecks}
                        value={batchChecked}
                        checked={batchChecked}
                      />
                    </th>
                  )}
                  <th>Load</th>
                  <th>Delivery Date</th>
                  <th>Carrier</th>
                  <th>Driver</th>
                  <th>Terminal</th>
                  <th>PO #</th>
                  <th>Ticket #</th>
                  <th>Missing Ticket</th>
                  <th>Mileage</th>
                  <th>Product</th>
                  <th>Weight (tons)</th>
                  <th>Matches</th>
                  <th>Freight Rev ($)</th>
                  <th>FSC Rev ($)</th>
                  <th>Freight Cost ($)</th>
                  <th>FSC Cost ($)</th>
                  <th>Sand Rev ($)</th>
                  <th>Sand Cost ($)</th>
                  <th>Locked</th>
                  <th>Invoiced</th>
                  <th>Transferred</th>
                  <th>Ticket Match</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <LoadList
                  deliveredLoads={paginatedLoads}
                  enableCheckBoxes={enableCheckBoxes}
                  batchLoads={batchLoads}
                  setBatchLoads={setBatchLoads}
                  batchChecked={batchChecked}
                  setBatchChecked={setBatchChecked}
                />
              </tbody>
            </table>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              margin: "20px",
            }}
          >
            <Select
              key={"per-page"}
              options={pageOptions}
              onChange={selectPerPage}
              placeholder={perPage}
            />
            <Pagination
              count={count}
              variant="outlined"
              onChange={selectPage}
            />
          </div>
          {triggerBatchUpdate && (
            <BatchUpdatePopup
              reqBody={reqBody}
              title={title}
              endpoint={`${process.env.REACT_APP_BACKEND}/pc/loads-batch-action`}
              successMessage={successMessage}
              setStates={[setProjectLoads, setProjectTotals]}
              setStateKeys={["loads", "all_totals"]}
              setTrigger={setTriggerBatchUpdate}
              otherStates={[
                setBatchChecked,
                setBatchLoads,
                setEnableCheckBoxes,
                setCurrFilter,
              ]}
              otherStateValues={[false, [], false, "all"]}
            />
          )}
        </div>
      )
    );
  }
}
